import * as Sentry from '@sentry/react';

import { getEnvConstants } from 'helpers/envConstants';

const { RUNTIME_ENV, SENTRY_DSN, SENTRY_TRACES_SAMPLE_RATE, SENTRY_REPLAY_ERROR_RATE } =
  getEnvConstants();

export function initializeSentry() {
  if (!SENTRY_DSN) return;

  try {
    Sentry.init({
      beforeSend(event) {
        if (!event.exception) return event;

        if (event.exception.values.every(value => value.mechanism.type === 'onerror')) {
          return null;
        } else {
          return event;
        }
      },
      debug: window.location.search?.includes('sentryDebug=true'),
      dsn: SENTRY_DSN,
      allowUrls: [
        /https?:\/\/((.*).herokuapp.com)/,
        /localhost/,
        /tempo-dev/,
        /https?:\/\/((.*).homechef.com)/,
        /https?:\/\/((.*).tempomeals.com)/,
        /webpack/,
      ],
      environment: RUNTIME_ENV,
      ignoreErrors: [
        /Load failed/,
        'Failed to fetch',
        'NetworkError',
        'Non-Error promise rejection captured with value',
        "Failed to execute 'fetch'",
      ],
      integrations: [
        Sentry.featureFlagsIntegration(),
        Sentry.replayIntegration({
          maskAllInputs: true,
          maskAllText: false,
          networkDetailAllowUrls: [/api\/v2/],
          networkRequestHeaders: ['Cookie', 'Referer'],
          blockAllMedia: false,
          block: ['.pac-container'], // .pac-container surrounds Google Autocomplete input
        }),
        Sentry.thirdPartyErrorFilterIntegration({
          filterKeys: ['m341h4nd'],
          behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
        }),
      ],
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: SENTRY_REPLAY_ERROR_RATE,
      tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE,
    });
    return true;
  } catch (e) {
    console.warn(`WARNING: Sentry initialization failed: ${e}`); // eslint-disable-line no-console
    return null;
  }
}

const sentry = initializeSentry();

export function setUser({ id, email, name }) {
  if (sentry) {
    Sentry.setUser({ id: id, email: email, username: name });
  }
}

export function captureException(error, context = {}) {
  if (sentry) {
    Sentry.captureException(error, { contexts: { 'Provided Context': context } });
  }
}

export function captureInfo(error, context = {}) {
  if (sentry) {
    Sentry.withScope(function (scope) {
      scope.setLevel('info');

      Sentry.captureException(error, { contexts: { 'Provided Context': context } });
    });
  }
}
